require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./insights-tips-for-entrepreneurs.json") })
        }
      }, "path---insights-tips-for-entrepreneurs");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---insights-tips-for-entrepreneurs!./.cache/json/insights-tips-for-entrepreneurs.json
// module id = 1129
// module chunks = 231608221292675